import { Alert } from '@mantine/core'
import { IconAlertCircle } from '@tabler/icons-react'

export function ErrorAlert() {
  return (
    <Alert icon={<IconAlertCircle size={16} />} title="Virhe" color="red">
      Tietojen lataaminen epäonnistui. Yritä uudelleen.
    </Alert>
  )
}
